import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleCheckboxInputComponentModule } from '@accredible-frontend-v2/new-components/checkbox-input';
import { AccredibleChipComponentModule } from '@accredible-frontend-v2/new-components/chip';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { AccredibleTextInputModule } from '@accredible-frontend-v2/new-components/text-input';
import { AccredibleTooltipModule } from '@accredible-frontend-v2/new-components/tooltip';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AccredibleMultiSearchFilterComponent } from './multi-search-filter.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AccredibleIconComponentModule,
    AccredibleButtonComponentModule,
    AccredibleChipComponentModule,
    AccredibleTextInputModule,
    AccredibleCheckboxInputComponentModule,
    AccredibleTooltipModule,
    InfiniteScrollModule,
    TranslocoModule,
  ],
  declarations: [AccredibleMultiSearchFilterComponent],
  exports: [AccredibleMultiSearchFilterComponent],
})
export class AccredibleMultiSearchFilterModule {}
